import kountSDK from '@kount/kount-web-client-sdk';
import { v4 as uuid } from 'uuid';
import { LOCAL_STORAGE } from '@constants';

import 'thirdPartyScripts/geetest';

import './index';

const KOUNT_ENV = process.env.KOUNT_ENV || '';
const KOUNT_MERCHANT_ID = process.env.KOUNT_MERCHANT_ID || '';
const DISABLE_KOUNT_ACCESS = process.env.DISABLE_KOUNT_ACCESS || '';

if (!DISABLE_KOUNT_ACCESS || DISABLE_KOUNT_ACCESS.toUpperCase() === 'FALSE') {
  const kountConfig = {
    clientID: KOUNT_MERCHANT_ID,
    environment: KOUNT_ENV,
    isSinglePageApp: true,
  };
  const sessionId = uuid().replace(/-/g, '');
  const sdk = kountSDK(kountConfig, sessionId);
  if (sdk) {
    localStorage.setItem(LOCAL_STORAGE.KOUNT_SESSIONID, sessionId);
  }
}
